export const ocrReportConstants = {
    GET_OCR_REPORT: "GET_OCR_REPORT",
  };